export default __webpack_public_path__ + "images/J7.5142818.png";